import { InjectionToken } from '@angular/core';
import { ObservableResult } from '../../models/result.model';
import { IAbsenceTypes, ProfileData, UserUpdateData } from '../../models/profile/profile.model';
import { IUser, ProfileStudio } from '../../models/leads/leads.model';


/** Injection token for the data service */
export const PROFILE_DATA_SERVICE = new InjectionToken<ProfileDataService>('[Profile] ProfileDataService');

export interface ProfileDataService {

  getUserProfile(): ObservableResult<ProfileData>;

  getSubordinates(): ObservableResult<IUser[]>;

  updateUserProfile(profileData: UserUpdateData): ObservableResult<void>;

  getAbsenceTypes(): ObservableResult<IAbsenceTypes[]>;

  getSubstitutes(): ObservableResult<IUser[]>;

  getStudios(): ObservableResult<ProfileStudio[]>;
}
